import { Component, OnInit, OnDestroy, Inject, ElementRef, ViewChild} from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MonitoringSourcePickerFieldModel } from '../../../Shared/models/monitoring-source-picker-field.model';
import { MonitoringBackEndDataSourceModel } from '../../../Shared/models/monitoring-back-end-data-source.model';
import { BriefingListItemModel } from '../../../../Common/MonitorShared/model/briefing-list-item.model';
import { BriefingModel } from '../../models/briefing.model';
import { BriefingQuickModel } from '../../models/briefing-quick.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { NumberFieldModel } from '../../../../Common/PageBuilder/models/number-field.model';
import { ImageLightBoxComponent } from '../../../../Common/Dialogs/components/ImageLightBox/image-light-box.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { MonitoringRoutingService } from '../../../Core/services/monitoring-routing.service';
import { MentionSearchService } from '../../../Core/services/mention-search.service';
import { BriefingTemplateService } from '../../../../Common/MonitorShared/services/briefing-template.service';
import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { BriefingsService } from '../../services/briefings.service';
import { briefingSavedSourceOrganizeOptions, briefingUnsavedSourceOrganizeOptions } from '../../models/briefing-organize-by-options.model';
import { getBriefingSortByOptions, getAutomaticBlockSortOptions } from '../../models/briefing-sort-by-options.model';
import { FocusHelper } from '../../../../Common/Forms/helpers/focus.helper';
import { ManageTemplateDialogComponent } from '../../../../Common/MonitorShared/components/ManageTemplateDialog/manage-template-dialog.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { MonitoringSeriesTypeEnum } from '../../../Shared/enums/monitoring-series-type.enum';
import { monitoringFiltersEnum } from '../../../Shared/enums/monitoring-filters.enum';
import { BriefingOrganizeByEnum } from '../../enums/briefing-organize-by.enum';
import { BriefingSortByEnum } from '../../enums/briefing-sort-by.enum';
import { BriefingTypeEnum } from '../../enums/briefing-type.enum';
import { BriefingStatusEnum } from '../../../../Common/MonitorShared/enum/briefing-status.enum';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { BriefingDeliveryMethodEnum } from '../../enums/briefing-delivery-method.enum';
import { BriefingConfigService } from '@Common/MonitorShared/services/briefing-config.service';
import { sortArrayByString } from '@Common/Misc/helpers/sort/sort.helper';
import { SortOrderEnum } from '@api/shared/enums/sort-order.enum';

enum NewBriefingTabsEnum {
    quickTemplates,
    savedTemplates,
    pastBriefings
}

enum BriefingTemplateOptionsEnum {
    one = 'BRIEFING_1',
    two = 'BRIEFING_2',
    three = 'BRIEFING_3',
    saved = 'saved'
}

@Component({
    selector: 'agpr-new-briefing',
    templateUrl: './new-briefing.component.html',
    styleUrls: ['./new-briefing.component.scss'],
    providers: [MentionSearchService],
    standalone: false
})
export class NewBriefingComponent implements OnInit, OnDestroy {

    @ViewChild('quickCreateForm', {read: ElementRef}) quickCreateForm: ElementRef;

    selectedTabIndex: NewBriefingTabsEnum = NewBriefingTabsEnum.quickTemplates;

    selectedQuickTemplateOption: BriefingTemplateOptionsEnum = BriefingTemplateOptionsEnum.one;

    useQuickBriefing: boolean = false;

    dataSource: MonitoringBackEndDataSourceModel;
    tagIds: number[] = [];

    folderEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.folder;
    topicEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.topic;
    mediaSubscriptionEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.subscription;
    tagEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.tag;
    tagGroupEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.tagGroup;
    sourceGroupEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.sourceGroup;
    socialTopicEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.socialTopic;
    themeEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.theme;
    aiAgentEnum: MonitoringSeriesTypeEnum = MonitoringSeriesTypeEnum.aiAgent;
    isUnsavedDataSource: boolean = false;
    unsavedDataSourceEnum: MonitoringSeriesTypeEnum[] = [
        this.topicEnum,
        this.mediaSubscriptionEnum,
        this.socialTopicEnum,
        this.themeEnum
    ];

    sourceField: MonitoringSourcePickerFieldModel = new MonitoringSourcePickerFieldModel(
        null,
        'backendDataSource',
        '',
        '',
        {
            dataSourceLabel: 'Monitoring.sourcePickerField.addCoverageFrom',
            dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
            mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.briefingsResultFeedbackMessage',
            maxNumberOfMentions: 1000,
            dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
            dataSourceOptions: [
                new DropdownOptionModel('Monitoring.source.type.folder', MonitoringSeriesTypeEnum.folder),
                new DropdownOptionModel('Monitoring.source.type.topic', MonitoringSeriesTypeEnum.topic),
                new DropdownOptionModel('Monitoring.source.type.subscription', MonitoringSeriesTypeEnum.subscription),
                new DropdownOptionModel('Monitoring.source.type.tag', MonitoringSeriesTypeEnum.tag),
                new DropdownOptionModel('Monitoring.source.type.tagGroup', MonitoringSeriesTypeEnum.tagGroup),
                new DropdownOptionModel('Monitoring.source.type.sourceGroup', MonitoringSeriesTypeEnum.sourceGroup),
                new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
                new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme),
                new DropdownOptionModel('Reports.series.type.aiAgent', MonitoringSeriesTypeEnum.aiAgent)
            ],
            showTooManyMentionsError: false,
            showFilters: true,
            orderedMercuryFilters: MentionSearchService.defaultOrderedMercuryFilters.filter((x) => {
                // @TODO: This list should vary depending on the selected source, different options are available for saved vs unsaved mentions
                // likely needs a refactor
                return x !== monitoringFiltersEnum.domainAuthority;
            }),
            separatedErrors: true
        }
    );

    organizeByEnum = BriefingOrganizeByEnum;
    organizeBy: BriefingOrganizeByEnum;
    organizeOptions: {label: string; value: BriefingOrganizeByEnum}[] = briefingSavedSourceOrganizeOptions;
    selectedOrganizeOption: DropdownOptionModel = new DropdownOptionModel();

    sortBy: BriefingSortByEnum;
    sortByOptions: {label: string; value: BriefingSortByEnum}[] = getBriefingSortByOptions();
    selectedSortByOption: DropdownOptionModel = new DropdownOptionModel();

    numberFieldModel = new NumberFieldModel(
        null,
        'pageSize',
        'Briefings.dynamicMentionsList.form.numberOfMentions',
        null,
        'Briefings.dynamicMentionsList.form.selectPageSize.short.placeholder',
        1000,
        1,
        'Briefings.dynamicMentionsList.form.numberOfMentionsTooltip',
        'top'
    );
    maxNumberOfMentions: number = 10;
    private mentionCount: number = 0;

    selectedTemplateOption: BriefingTemplateOptionsEnum;

    briefingTemplateOptions = BriefingTemplateOptionsEnum;

    templateListItems: BriefingListItemModel[];
    selectedTemplate: BriefingListItemModel = null;

    briefingListItems: BriefingListItemModel[];
    selectedBriefing: BriefingListItemModel = null;

    showDataSourceError: boolean = false;
    showMaxNumberOfMentionsError: boolean = false;

    loadingTemplates: boolean = true;

    readonly buttonTypesEnum = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly monitoringSeriesTypeEnum = MonitoringSeriesTypeEnum;
    readonly newBriefingTabsEnum = NewBriefingTabsEnum;

    private hasEngagementUpdates: boolean = false;
    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        private monitoringRoutingService: MonitoringRoutingService,
        private mentionSearchService: MentionSearchService,
        private briefingTemplateService: BriefingTemplateService,
        private userPreferencesService: UserPreferencesService,
        private briefingsService: BriefingsService,
        private briefingConfigService: BriefingConfigService,
        @Inject(APP_BASE_HREF) public appBaseHref: string
    ) {
        this.dataSource = new MonitoringBackEndDataSourceModel(this.folderEnum);
    }

    ngOnInit(){
        this.organizeBy = this.organizeOptions[0].value;
        this.selectedOrganizeOption = this.organizeOptions[0];

        this.sortBy = this.sortByOptions[0].value;
        this.selectedSortByOption = this.sortByOptions[0];

        this.subscriptions.push(
            this.mentionSearchService.getMentionCount().subscribe(
                count => this.searchActionUpdate(count)
            ),
            // get saved templates
            combineLatest([
                this.briefingTemplateService.all$,
                this.userPreferencesService.getUserAppPreferences().pipe(
                    map(userAppPrefs => userAppPrefs.monitoringPrefs.briefingsPrefs.defaultBriefingTemplate)
                )
            ]).subscribe(([briefingTemplateListItems, briefingTemplatePreference]) => {
                this.templateListItems = [];
                if (briefingTemplateListItems) {
                    this.templateListItems = briefingTemplateListItems
                        .filter(item => item.deliveryMethod !== BriefingDeliveryMethodEnum.ONLINE)
                        .slice();

                    sortArrayByString(this.templateListItems, 'name', SortOrderEnum.ascending);

                    if ([this.briefingTemplateOptions.one,
                        this.briefingTemplateOptions.two,
                        this.briefingTemplateOptions.three].includes(
                        briefingTemplatePreference as BriefingTemplateOptionsEnum
                    )) {
                        this.selectedTemplateOption = briefingTemplatePreference as BriefingTemplateOptionsEnum;
                        this.selectedQuickTemplateOption = briefingTemplatePreference as BriefingTemplateOptionsEnum;
                    } else {
                        const template = briefingTemplateListItems.find(x => x.id.toString() === briefingTemplatePreference);
                        if (template) {
                            this.selectedTemplateOption = BriefingTemplateOptionsEnum.saved;
                            this.selectedTemplate = template;
                        }
                    }
                }
            }),
            // get past briefings
            this.briefingsService.getBriefingListItems().subscribe(
                list => {
                    if (list){
                        this.briefingListItems = list.slice().filter(item => item.deliveryMethod === BriefingDeliveryMethodEnum.EMAIL).sort(
                            (a, b) => {
                                const aSortDate = a.modifiedDate ? +a.modifiedDate : +a.createdDate;
                                const bSortDate = b.modifiedDate ? +b.modifiedDate : +b.createdDate;
                                return bSortDate - aSortDate;
                            }
                        );
                    }
                }
            ),
            this.briefingsService.hasDefaultTemplates().subscribe(
                hasDefaultTemplates => this.loadingTemplates = !hasDefaultTemplates
            ),
            this.briefingConfigService.getConfig().pipe(filter(x => !!x)).subscribe(config => {
                this.hasEngagementUpdates = config.hasEngagementUpdates;

                if (config.hasEngagementUpdates) {
                    this.sortByOptions.push({
                        label: 'Briefings.input.sortMentionsBy.engagementMost',
                        value: BriefingSortByEnum.ENGAGEMENT_MOST
                    });
                }
            })
        );

    }


    changeTabs(index: number): void {
        this.selectedTabIndex = index;
    }

    preview(previewImageSrc: string): void {
        this.coreDialogService.open(
            ImageLightBoxComponent,
            {
                inputs: {
                    id: 'briefing-template-preview',
                    src: previewImageSrc,
                    height: 540
                }
            }
        );
    }

    sourceSelected(dataSource: MonitoringBackEndDataSourceModel): void {
        this.dataSource = dataSource;
        this.validateDataSource();

        const isUnsavedDataSource = this.unsavedDataSourceEnum.includes(this.dataSource.type);
        if (this.isUnsavedDataSource !== isUnsavedDataSource) {
            // if the new source type change between saved source and unsaved source, we reset organize by and sort by field
            if (isUnsavedDataSource) {
                this.organizeBy = BriefingOrganizeByEnum.ALL;
                this.organizeOptions = briefingUnsavedSourceOrganizeOptions;
                this.selectedOrganizeOption = this.organizeOptions[0];

                this.sortByOptions = getAutomaticBlockSortOptions();
                this.selectedSortByOption = this.sortByOptions[0];
                this.sortBy = this.sortByOptions[0].value;
            } else {
                this.organizeBy = BriefingOrganizeByEnum.MANUAL;
                this.organizeOptions = briefingSavedSourceOrganizeOptions;
                this.selectedOrganizeOption = this.organizeOptions[0];

                this.sortByOptions = getBriefingSortByOptions();
                this.selectedSortByOption = this.sortByOptions[0];
                this.sortBy = this.sortByOptions[0].value;
            }
            this.isUnsavedDataSource = isUnsavedDataSource;

            if (this.hasEngagementUpdates) {
                this.sortByOptions.push({
                    label: 'Briefings.input.sortMentionsBy.engagementMost',
                    value: BriefingSortByEnum.ENGAGEMENT_MOST
                });
            }
        }

        switch (this.dataSource.type) {
            case this.folderEnum:
            case this.tagEnum:
            case this.tagGroupEnum:
            case this.sourceGroupEnum:
                this.sourceField.showResultsFeedback = true;
                this.sourceField.showLoadingFeedback = true;
                break;
            case this.topicEnum:
            case this.mediaSubscriptionEnum:
            case this.socialTopicEnum:
            case this.themeEnum:
                this.sourceField.showResultsFeedback = false;
                this.sourceField.showLoadingFeedback = false;
                this.tagIds = [];
                break;
        }
    }

    /**
     * Handles update to mention search
     */
    searchActionUpdate(count: number): void {
        if (this.dataSource.type !== this.topicEnum) {
            this.mentionCount = count;
            if ([this.folderEnum, this.tagEnum].includes(this.dataSource?.type)
                    && count > this.briefingsService.maxNumberOfMentionsInBriefing) {
                this.briefingsService.showMentionLimitReachedDialog();
            }
        }
    }

    onOrganizeByChanged(organizeBy: BriefingOrganizeByEnum): void {
        this.organizeBy = organizeBy;
    }

    onSortByChanged(sortBy: BriefingSortByEnum): void {
        this.sortBy = sortBy;
    }

    onMaxNumberOfMentionsChanged(maxNumberOfMentions: number) {
        this.maxNumberOfMentions = maxNumberOfMentions;
        this.validateMaxNumberOfMentions();
    }

    onTagIdsChanged(tagIds: number[]): void {
        this.tagIds = tagIds.slice();
    }

    openManageTemplateDialog(): void {
        const overlayContainer = document.getElementById('main-content');
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: overlayContainer
            }
        };
        this.coreDialogService.open(ManageTemplateDialogComponent, io);
    }

    onQuickTemplateSelect(option: BriefingTemplateOptionsEnum): void {
        this.selectedQuickTemplateOption = option;
    }

    onTemplateSelect(template: BriefingListItemModel): void {
        this.selectedTemplate = template;
        this.selectedTemplateOption = BriefingTemplateOptionsEnum.saved;
    }

    onBriefingSelect(briefing: BriefingListItemModel): void {
        this.selectedBriefing = briefing;
    }

    validateDataSource(): boolean {
        if (!this.showDataSourceError) {
            // if errors are not on, then ignore the error in the field
            this.sourceField.showDataSourceError = false;
            return;
        }
        const isValid = this.dataSource?.id;
        this.sourceField.showDataSourceError = !isValid;
        return !!isValid;
    }

    validateMaxNumberOfMentions(): boolean {
        let isValid = true;
        if (this.dataSource.type === this.topicEnum || this.dataSource.type === this.mediaSubscriptionEnum) {
            isValid = this.maxNumberOfMentions > 0;
        }
        this.showMaxNumberOfMentionsError = !isValid;
        return isValid;
    }

    /**
     *  Validation for Use Quick Template Form
     */
    isValid(): boolean {
        // need to perform each check to show all relevant error messages
        let isValid = true;
        isValid &&= this.validateDataSource();
        isValid &&= this.validateMaxNumberOfMentions();
        if (this.organizeBy === BriefingOrganizeByEnum.TAGS){
            isValid &&= this.tagIds.length > 0;
        }
        return isValid;
    }

    createQuickBriefing(briefing: BriefingModel): void {
        const quickModel = new BriefingQuickModel();

        quickModel.dataSourceModel = this.dataSource;
        if (quickModel.dataSourceModel.combinedSearchCriteria) {
            quickModel.dataSourceModel.combinedSearchCriteria.facets = [];
        }

        quickModel.organizeBy = this.organizeBy;
        quickModel.sortBy = this.sortBy;

        if (this.dataSource.type === this.folderEnum
            || this.dataSource.type === this.tagEnum
            || this.dataSource.type === this.tagGroupEnum
            || this.dataSource.type === this.sourceGroupEnum
            || this.dataSource.type === this.aiAgentEnum
        ) {
            quickModel.numberOfMentions = this.mentionCount;
        } else {
            quickModel.numberOfMentions = this.maxNumberOfMentions;
        }

        quickModel.tagIds = this.tagIds;

        this.briefingsService.createQuickBriefing(quickModel, briefing);
    }

    createBriefing() {
        if (this.selectedTabIndex === NewBriefingTabsEnum.pastBriefings) {
            if (this.selectedBriefing) {
                this.briefingsService.cloneFromExistingBriefing(this.selectedBriefing.id);
            }
        } else if (this.selectedTabIndex === NewBriefingTabsEnum.savedTemplates) {
            if (this.selectedTemplate) {

                this.briefingTemplateService.getBriefingTemplate(this.selectedTemplate.id).subscribe((newBriefing) => {
                    delete newBriefing.id;
                    newBriefing.type = BriefingTypeEnum.BRIEFING;
                    newBriefing.status = BriefingStatusEnum.DRAFT;

                    this.briefingsService.setNewBriefing(newBriefing);
                });
            }
        } else {
            let newBriefing: BriefingModel;

            switch (this.selectedQuickTemplateOption) {
                case BriefingTemplateOptionsEnum.one:
                    newBriefing = this.briefingsService.getTemplateOne();
                    break;

                case BriefingTemplateOptionsEnum.two:
                    newBriefing = this.briefingsService.getTemplateTwo();
                    break;

                case BriefingTemplateOptionsEnum.three:
                    newBriefing = this.briefingsService.getTemplateThree();
                    break;
            }

            newBriefing.generalStyles.mention.showSectionHeading = false;

            if (this.useQuickBriefing) {
                this.showDataSourceError = true;
                if (!this.isValid()) {
                    requestAnimationFrame(() => FocusHelper.focusFirstError(this.quickCreateForm.nativeElement, '.agpr-form-message'));
                    return;
                }
                this.createQuickBriefing(newBriefing);
            } else {
                this.briefingsService.setNewBriefing(newBriefing);
            }
        }
    }

    cancel(): void {
        this.monitoringRoutingService.gotoBriefings();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
